// extracted by mini-css-extract-plugin
export default {"section":"styles_section__M2pj5","container":"styles_container__yqmDE","progressbarWrapper":"styles_progressbarWrapper__RCk3Q"};